// import numeral from 'numeral'
var numeral = require('numeral');

export function formatNumber(value,format){
  // chapuzilla porque el numeral asume porcentages en "por 1"
  if(format && format.indexOf('%')>=0) value = value/100
  
  let formattedValue = numeral(value).format(format || '0.00')
  return formattedValue
}